import { useEffect, useRef } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '@/hooks/useAppDispatch';

import { applyIdentityLogin, getActivePortalHomePath } from '@/store/identitySlice';

import { identityApi } from '@/api/identity.api';

import {

  resolveSsoExchangeError,

  notifySsoError,

  ssoErrorToastGuardKey,

  ssoExchangeGuardKey,

} from '@/utils/ssoErrorMessage';



const inflightIdentityExchange = new Map<string, Promise<Awaited<ReturnType<typeof identityApi.ssoExchange>>>>();



function exchangeIdentityOnce(exchangeToken: string) {

  let inflight = inflightIdentityExchange.get(exchangeToken);

  if (!inflight) {

    inflight = identityApi.ssoExchange(exchangeToken).finally(() => {

      inflightIdentityExchange.delete(exchangeToken);

    });

    inflightIdentityExchange.set(exchangeToken, inflight);

  }

  return inflight;

}



export function IdentityOAuthCallbackPage() {

  const [params] = useSearchParams();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const startedRef = useRef(false);



  useEffect(() => {

    const exchangeToken = params.get('exchangeToken');

    if (!exchangeToken) {

      navigate('/identity/login', { replace: true });

      return;

    }



    const guardKey = ssoExchangeGuardKey(exchangeToken).replace('oauth:sso-exchange:', 'oauth:identity-exchange:');

    const messageKey = `${guardKey}:message`;

    const guardState = sessionStorage.getItem(guardKey);



    if (guardState === 'done') {

      navigate('/identity/login', { replace: true });

      return;

    }

    if (guardState === 'failed') {

      navigate('/identity/login', { replace: true });

      return;

    }

    if (guardState === 'pending' || startedRef.current) {

      return;

    }

    startedRef.current = true;

    sessionStorage.setItem(guardKey, 'pending');



    void (async () => {

      try {

        const result = await exchangeIdentityOnce(exchangeToken);

        sessionStorage.setItem(guardKey, 'done');

        sessionStorage.removeItem(messageKey);

        dispatch(applyIdentityLogin(result));

        if ((result.availablePortals?.length ?? 0) > 1) {

          navigate('/identity/portals', { replace: true });

          return;

        }

        if (result.activeProfileId && result.activePortalCode && result.organizationId) {

          navigate(getActivePortalHomePath({

            identityId: result.identityId,

            identityUuid: result.identityUuid,

            email: result.email,

            activeProfileId: result.activeProfileId,

            activePortalCode: result.activePortalCode,

            organizationId: result.organizationId,

            organizationName: result.organizationName,

            permissions: result.permissions ?? [],

            availablePortals: result.availablePortals ?? [],

          }), { replace: true });

        } else {

          navigate('/identity/portals', { replace: true });

        }

      } catch (err) {

        const message = resolveSsoExchangeError(err, 'login');

        sessionStorage.setItem(guardKey, 'failed');

        sessionStorage.setItem(messageKey, message);

        notifySsoError(message, ssoErrorToastGuardKey('identity-oauth', exchangeToken));

        navigate('/identity/login', { replace: true });

      }

    })();

  }, [dispatch, navigate, params]);



  return (

    <div className="min-h-screen flex items-center justify-center">

      <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary-600 border-t-transparent" />

    </div>

  );

}


